import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
}

export const LooseRockIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* Loose rock - scattered rocks above ground */}
    <path d="M3 18h18" />
    <path d="M4 18l2-3 2 1 1-2 2 4" />
    <path d="M13 18l1.5-4 2 2 1.5-3 3 5" />
    <path d="M8 10l1 2-2 1" />
    <path d="M15 8l2 1-1 2" />
  </svg>
);
